module.exports = __webpack_public_path__ + "static/img/Demitric-Sifakula.e6228b8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Demitric-Sifakula.jpg
// module id = Uzi/
// module chunks = 0